import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import BuildingExcellence from "./sections/BuildingExcellence";
import TheStandardOfLuxury from "./sections/TheStandardOfLuxury";
import OurExpertise from "./sections/OurExpertise";
import Luxurypatioservices from "./sections/Luxurypatioservices";
import Gallery from "./sections/Gallery";
import ProvenResults from "./sections/ProvenResults";
import ProjectGallery from "./sections/ProjectGallery";
import RequestAnEstimate from "./sections/RequestAnEstimate";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <BuildingExcellence />
      <TheStandardOfLuxury />
      <OurExpertise />
      <Luxurypatioservices />
      <Gallery />
      <ProvenResults />
      <ProjectGallery />
      <RequestAnEstimate />
      <Footer />
    </div>;
}